import { FC, ReactNode, useMemo, useState } from 'react';
import GlobalSearchInput from './GlobalSearchInput';
import { SearchContext } from './GlobalSearchPopup';
import ProjectsNav from './ProjectsNav';
import ShortcutsBar from './ShortcutsBar';
import { bionicPlatformSuggestions, projectSuggestions } from './data';
import React from 'react';

interface GlobalSearchProps {
  handleClose: () => void;
  searchForTerm: (term: string) => void;
  searchContext?: SearchContext;
}

const GlobalSearch: FC<GlobalSearchProps> = ({
  handleClose,
  searchContext,
  searchForTerm,
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const doSearch = (term: string) => {
    setSearchTerm(term);
    searchForTerm(term);
  };

  return (
    <div className="grid relative w-full grid-rows-[auto_1fr_auto]">
      <GlobalSearchInput
        enterSearchTerm={doSearch}
        searchContext={searchContext}
        searchTerm={searchTerm || null}
        handleClose={handleClose}
      />
      <Navigation selectSearchTerm={doSearch} searchContext={searchContext} />
      <ShortcutsBar handleClose={handleClose} />
    </div>
  );
};

const Navigation: FC<{
  selectSearchTerm: Function;
  searchContext?: SearchContext;
}> = ({ selectSearchTerm, searchContext }) => {
  const suggestions = useMemo(
    () =>
      searchContext?.scope === 'project'
        ? projectSuggestions
        : bionicPlatformSuggestions,
    []
  );

  return (
    <div className="grid relative w-full gap-3 my-4 px-[18px]">
      <SectionTitle>Navigate to</SectionTitle>
      <ProjectsNav />
      {suggestions.length ? (
        <div className="grid relative gap-2 mt-3">
          <SectionTitle>
            {searchContext?.scope === 'project'
              ? 'Project suggestions'
              : 'Suggestions'}
          </SectionTitle>
          <div className="grid relative gap-1">
            {suggestions.map((suggestion, index) => (
              <button
                key={index}
                className="block relative text-[14px] text-left rounded-[4px] py-3 hover:bg-white/20 hover:px-4 transition-all duration-75 ease-out"
                onClick={() => selectSearchTerm(suggestion)}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

const SectionTitle: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="block relative text-[10px] font-semiBold uppercase tracking-widest text-bionic-muted">
    {children}
  </div>
);

export default GlobalSearch;
